import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { Site } from 'shared/hooks';
import { ShiftDetail } from 'api/services/shift/schema/shift-detail.schema';

export const useOgpGetShift = (site: Site, shiftId: string, enabled?: boolean) => {
  const queryFn = async () => await sharedShiftService.getShiftDetail(site, shiftId);
  const queryKey = QUERY_KEYS.shift(shiftId);

  return useQuery<Promise<ShiftDetail>, Error, ShiftDetail>({
    queryKey,
    queryFn,
    enabled: !!shiftId && enabled !== false,
  });
};
